import GenericHoc from 'src/common/generic-hoc';
import React, { useEffect, useRef } from 'react';
import { Drawer, Button, message } from 'antd';
import 'antd/dist/antd.css';
import { HocOptions } from 'src/common/generic-hoc.types';
import { setTicketingToolVisibility, setTicketingToolURL, setTicketingToolOrgData } from './TicketManagement.actions';
import { TicketManagementProps } from './TicketManagement.utils';
import { useTranslation } from 'react-i18next';
import { getOrgConfig } from './TicketManagement.api';
import config from 'src/globals';

const { WB_BASE_URL } = config;

const TicketManagement = (props: TicketManagementProps) => {
  const {
    visible,
    setTicketingToolVisibility: setVisible,
    ticketingToolURL,
    setTicketingToolURL,
    setTicketingToolOrgData,
    showTicketingTool,
  } = props;

  const { t } = useTranslation();
  const iframeRef: any = useRef(null);

  const fetchOrgConfig = async () => {
    const keyParam = ticketingToolURL?.split('?')?.[1]?.split('&')?.[0];
    if (keyParam && WB_BASE_URL) {
      const response = await getOrgConfig(keyParam);
      if (response && response.isSuccess) {
        setTicketingToolOrgData(response.data?.[0] || {});
      } else {
        message.error('Failed to fetch org config');
      }
    }
  };

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    setTicketingToolURL(ticketingToolURL);
    fetchOrgConfig();

    const messageListener = (event) => {
      if (event.data?.type === 'CLOSE_RAISE_TICKET_DRAWER') {
        onClose();
      }
    };

    window.addEventListener('message', messageListener);

    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, []);

  return (
    <div>
      {showTicketingTool && ticketingToolURL ? (
        <Button
          type="primary"
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000,
          }}
          onClick={showDrawer}
        >
          {t('Raise Ticket')}
        </Button>
      ) : null}
      <Drawer
        placement="right"
        onClose={onClose}
        closable={false}
        visible={visible}
        width={520}
        bodyStyle={{ padding: 0 }}
        style={{ zIndex: 1400 }}
      >
        <iframe
          ref={iframeRef}
          id="myIframe"
          src={ticketingToolURL}
          style={{ width: '100%', height: '100%', border: 'none' }}
          title="Iframe Example"
        />
      </Drawer>
    </div>
  );
};

const mapStateToProps = ({ masterData, ticketingTool }) => {
  const { ticketing_tool_url, show_ticketing_tool } = masterData;
  const lang = window.localStorage.getItem('lng') || 'en';
  const updatedTicketingToolURL = `${ticketing_tool_url}&lng=${lang}`;
  return {
    visible: ticketingTool.visible,
    ticketingToolURL: ticketingTool.ticketingToolURL || updatedTicketingToolURL,
    showTicketingTool: show_ticketing_tool,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTicketingToolVisibility: (data) => dispatch(setTicketingToolVisibility(data)),
    setTicketingToolURL: (data) => dispatch(setTicketingToolURL(data)),
    setTicketingToolOrgData: (data) => dispatch(setTicketingToolOrgData(data)),
  };
};

const hocConfig: HocOptions = {
  connectRedux: {
    useRedux: true,
    mapStateToProps,
    mapDispatchToProps,
  },
  connectRouter: true,
  connectTranslession: true,
};

export default GenericHoc(hocConfig)(TicketManagement);
